import { IndicatorTypeEnums, TransportBuildingMaterialErrors } from "@/enums";

const _indicatorTypeEnums = IndicatorTypeEnums.get();
const _transportBuildingMaterialErrors = TransportBuildingMaterialErrors.get();

type EmissionByIndicator = { [key in keyof typeof _indicatorTypeEnums]: number };

type TransportMaterial = {
  id: string;
  name: string;
};

type TransportBuildingMaterial = {
  id: string;
  name: string;
  weight: number;
  emission: EmissionByIndicator;
  error?: {
    message: string;
    type: typeof _transportBuildingMaterialErrors;
  };
  wasteMapping?: {
    id: string;
    customPercentage?: number;
    customWeight?: number;
    materialWasteTypeId?: string;
  };
};

type TransportInventoryElementType = {
  weight: number;
  material: TransportMaterial;
  transportBuildingMaterial: TransportBuildingMaterial[];
};

type TransportInventoryType = TransportInventoryElementType[];

export type { TransportMaterial, TransportBuildingMaterial, TransportInventoryType, TransportInventoryElementType };
